(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["md-engagement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("md-engagement")) {
    class MdEngagement extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === "true") return;
        this.dataset.bound = "true";
        this.notice = this.querySelector(".md-exit");
        this.enableExit = this.dataset.enableExit === "true";
        this.enableTab = this.dataset.enableTab === "true";
        this.days = Number(this.dataset.days || 3);
        this.tabMessages = this.parseTabMessages();
        this.shown = false;
        this.engaged = false;
        this.storageKey = "md-exit-intent-v2";
        this.originalTitle = document.title;
        this.titleTimer = null;
        this.titleIndex = 0;

        this.querySelectorAll("[data-md-exit-close]").forEach((el) => {
          el.addEventListener("click", () => this.close());
        });

        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onVisibility = this.onVisibility.bind(this);

        if (this.enableExit) {
          document.addEventListener("mousemove", this.onMouseMove, { passive: true });
          document.documentElement.addEventListener("mouseleave", this.onMouseLeave);
        }

        if (this.enableTab && this.tabMessages.length) {
          document.addEventListener("visibilitychange", this.onVisibility);
        }
      }

      disconnectedCallback() {
        document.removeEventListener("mousemove", this.onMouseMove);
        document.documentElement.removeEventListener("mouseleave", this.onMouseLeave);
        document.removeEventListener("visibilitychange", this.onVisibility);
        this.stopTitleRotate();
        document.title = this.originalTitle;
      }

      parseTabMessages() {
        try {
          const parsed = JSON.parse(this.dataset.tabMessages || "[]");
          return parsed.map((item) => String(item).trim()).filter(Boolean);
        } catch (error) {
          return [];
        }
      }

      dismissed() {
        try {
          const until = Number(localStorage.getItem(this.storageKey) || 0);
          return until > Date.now();
        } catch (error) {
          return false;
        }
      }

      remember() {
        try {
          localStorage.setItem(this.storageKey, String(Date.now() + this.days * 86400000));
        } catch (error) {}
      }

      open() {
        if (!this.enableExit || !this.notice || this.shown || this.dismissed() || !this.engaged) return;
        this.shown = true;
        this.notice.hidden = false;
        this.remember();
      }

      close() {
        if (this.notice) this.notice.hidden = true;
      }

      onMouseMove(event) {
        if (event.clientY > 80) this.engaged = true;
      }

      onMouseLeave(event) {
        if (!this.engaged) return;
        if (window.matchMedia("(pointer: coarse)").matches) return;
        if (event.clientY > 0) return;
        this.open();
      }

      onVisibility() {
        if (document.hidden) {
          this.originalTitle = document.title;
          this.titleIndex = 0;
          document.title = this.tabMessages[0];
          this.startTitleRotate();
        } else {
          this.stopTitleRotate();
          document.title = this.originalTitle;
        }
      }

      startTitleRotate() {
        this.stopTitleRotate();
        if (this.tabMessages.length < 2) return;
        this.titleTimer = window.setInterval(() => {
          this.titleIndex = (this.titleIndex + 1) % this.tabMessages.length;
          document.title = this.tabMessages[this.titleIndex];
        }, 2200);
      }

      stopTitleRotate() {
        if (this.titleTimer) {
          clearInterval(this.titleTimer);
          this.titleTimer = null;
        }
      }
    }

    customElements.define("md-engagement", MdEngagement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  /*
   * This block ensures ProductCardSlider is defined and its CSS is injected
   * on the PDP page load — BEFORE product-recommendations fetches cards via
   * AJAX. Section {% javascript %} renders before </body> unconditionally,
   * even when recommendations.performed is false on first load. Snippet
   * {% javascript %} (in card-product1.liquid) only runs when the snippet is
   * server-rendered, which on PDP never happens on initial load.
   * The customElements.get guard prevents double-define on pages (homepage,
   * collections) where card-product1.liquid's own {% javascript %} already ran.
   */
  (function () {
    if (!document.getElementById('hdt-pr-slider-css')) {
      var style = document.createElement('style');
      style.id = 'hdt-pr-slider-css';
      style.textContent = [
        'product-card-slider,.hdt-pr-slider{display:block;width:100%;height:100%;}',
        '.hdt-pr-slider{position:relative;overflow:hidden;}',
        '.hdt-pr-slider__track{display:flex;width:100%;height:100%;touch-action:pan-y;cursor:grab;transition:transform 0.35s cubic-bezier(0.22,1,0.36,1);will-change:transform;}',
        '.hdt-pr-slider__track.is-dragging{cursor:grabbing;transition:none;}',
        '.hdt-pr-slider__slide{flex:0 0 100%;min-width:100%;height:100%;}',
        '.hdt-pr-slider__slide .hdt-card-product__media-wrapp{width:100%;height:100%;pointer-events:auto;}',
        '.hdt-pr-slider.is-swiping .hdt-card-product__media-wrapp{pointer-events:none;}',
        '.hdt-pr-slider__arrow{position:absolute;top:50%;z-index:3;display:flex;align-items:center;justify-content:center;width:26px;height:26px;margin-top:-13px;padding:0;border:none;border-radius:50%;background:rgba(255,255,255,0.92);color:#111;cursor:pointer;opacity:0;transition:opacity 0.18s ease,background-color 0.18s ease;}',
        '.hdt-pr-slider__arrow--prev{left:8px;}',
        '.hdt-pr-slider__arrow--next{right:8px;}',
        '.hdt-pr-slider__arrow:hover{background:#fff;}',
        '.hdt-pr-slider__arrow:disabled{opacity:0!important;pointer-events:none;}',
        '.hdt-pr-slider__arrow svg{display:block;}',
        '.hdt-pr-slider__arrow::after{content:"";position:absolute;inset:-9px;}',
        '@media (hover:hover) and (pointer:fine){.hdt-pr-slider:hover .hdt-pr-slider__arrow:not(:disabled){opacity:1;}}',
        '@media (max-width:749px),(hover:none),(pointer:coarse){',
        '.hdt-pr-slider__arrow{opacity:1!important;width:20px;height:20px;margin-top:-10px;}',
        '.hdt-pr-slider__arrow--prev{left:6px;}',
        '.hdt-pr-slider__arrow--next{right:6px;}',
        '.hdt-pr-slider__arrow svg{width:6px;height:10px;}',
        '.hdt-pr-slider__arrow:disabled{opacity:0!important;}}',
        '@media (prefers-reduced-motion:reduce){.hdt-pr-slider__track{transition:none;}}'
      ].join('');
      document.head.appendChild(style);
    }

    if (!customElements.get('product-card-slider')) {
      class ProductCardSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.hdt-pr-slider__track');
          this.slides = Array.from(this.querySelectorAll('.hdt-pr-slider__slide'));
          this.prevBtn = this.querySelector('.hdt-pr-slider__arrow--prev');
          this.nextBtn = this.querySelector('.hdt-pr-slider__arrow--next');

          if (!this.track || this.slides.length <= 1) return;

          this.currentIndex = 0;
          this.isDragging = false;
          this.startX = 0;
          this.deltaX = 0;
          this.slideWidth = 0;

          this.onPrev = this.onPrev.bind(this);
          this.onNext = this.onNext.bind(this);
          this.onDragStart = this.onDragStart.bind(this);
          this.onDragMove = this.onDragMove.bind(this);
          this.onDragEnd = this.onDragEnd.bind(this);

          this.prevBtn?.addEventListener('click', this.onPrev);
          this.nextBtn?.addEventListener('click', this.onNext);

          this.track.addEventListener('touchstart', this.onDragStart, { passive: true });
          this.track.addEventListener('touchmove', this.onDragMove, { passive: true });
          this.track.addEventListener('touchend', this.onDragEnd);

          this.track.addEventListener('mousedown', this.onDragStart);
          window.addEventListener('mousemove', this.onDragMove);
          window.addEventListener('mouseup', this.onDragEnd);

          this._ro = new ResizeObserver(() => {
            const w = this.track.offsetWidth;
            if (w > 0) this.slideWidth = w;
            this.track.style.transition = 'none';
            this.track.style.transform = 'translateX(-' + (this.currentIndex * 100) + '%)';
            requestAnimationFrame(() => { this.track.style.transition = ''; });
          });
          this._ro.observe(this);

          this.updateArrowState();
        }

        disconnectedCallback() {
          this._ro?.disconnect();
          window.removeEventListener('mousemove', this.onDragMove);
          window.removeEventListener('mouseup', this.onDragEnd);
        }

        onPrev(e) { e.preventDefault(); this.goTo(this.currentIndex - 1); }
        onNext(e) { e.preventDefault(); this.goTo(this.currentIndex + 1); }

        goTo(index) {
          var max = this.slides.length - 1;
          this.currentIndex = Math.max(0, Math.min(index, max));
          this.track.style.transform = 'translateX(-' + (this.currentIndex * 100) + '%)';
          this.updateArrowState();
        }

        updateArrowState() {
          if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
          if (this.nextBtn) this.nextBtn.disabled = this.currentIndex === this.slides.length - 1;
        }

        getClientX(e) {
          return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
        }

        onDragStart(e) {
          var w = this.track.offsetWidth;
          if (w > 0) this.slideWidth = w;
          if (!this.slideWidth) return;
          this.isDragging = true;
          this.startX = this.getClientX(e);
          this.deltaX = 0;
          this.track.classList.add('is-dragging');
        }

        onDragMove(e) {
          if (!this.isDragging) return;
          this.deltaX = this.getClientX(e) - this.startX;
          if (Math.abs(this.deltaX) > 6) this.classList.add('is-swiping');
          var baseOffset = -this.currentIndex * this.slideWidth;
          this.track.style.transform = 'translateX(' + (baseOffset + this.deltaX) + 'px)';
        }

        onDragEnd() {
          if (!this.isDragging) return;
          this.isDragging = false;
          this.track.classList.remove('is-dragging');
          var threshold = this.slideWidth * 0.15;
          if (this.deltaX < -threshold && this.currentIndex < this.slides.length - 1) this.currentIndex += 1;
          else if (this.deltaX > threshold && this.currentIndex > 0) this.currentIndex -= 1;
          this.goTo(this.currentIndex);
          setTimeout(() => this.classList.remove('is-swiping'), 50);
        }
      }

      customElements.define('product-card-slider', ProductCardSlider);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
